"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normaliseTeamSlug = void 0;
const constants_1 = require("../constants");
const normaliseTeamSlug = (team_slug) => (team_slug === constants_1.UNSET_TEAM_SLUG ? undefined : team_slug || undefined);
exports.normaliseTeamSlug = normaliseTeamSlug;
